import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectedPanelEnum } from '@app/core/enums/selected-panel.enum';
import { productIconConfig } from '@app/my-zone/config/product-icon.config';
import { MyZoneRoutesEnum } from '@app/my-zone/my-zone-routes.enum';
import { AppRoutesEnum } from '@app/routes/app-routes.enum';
import { PanelExpandableComponent } from '@app/shared/ux/panel-expandable/panel-expandable.component';
import { ErrorInterface, InsurancePolicyActionService, PolicyProductIdEnum, PurchasedProductInterface } from 'outshared-lib';
import { filter } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { IntersectionObserverService } from '@app/core/services/intersection-observer.service';
import { IconGeneralIcon } from '@inshared/website-ui-components';

@Component({
    selector: 'ins-cancel-insurance-list',
    templateUrl: 'cancel-insurance-list.component.html',
    styleUrls: [ 'cancel-insurance-list.component.scss' ],
})
export class CancelInsuranceListComponent implements OnInit {

    @Input() public purchasedProduct: PurchasedProductInterface;
    @ViewChild(PanelExpandableComponent, {static: true}) panel: PanelExpandableComponent;

    public selectedPanelEnum: typeof SelectedPanelEnum;
    public productIdEnum: typeof PolicyProductIdEnum;
    public isDisabled: boolean;
    public errors: ErrorInterface[];

    public isScreenSmall$: Observable<boolean> = this.intersectionObserverService.isScreenSmall$;

    constructor(
        private intersectionObserverService: IntersectionObserverService,
        private insurancePolicyActionService: InsurancePolicyActionService,
        private route: ActivatedRoute,
        private router: Router,
    ) {
        this.selectedPanelEnum = SelectedPanelEnum;
        this.productIdEnum = PolicyProductIdEnum;
        this.isDisabled = false;
        this.errors = [];
    }

    public ngOnInit(): void {
        this.validateQueryParams();
    }

    public onClosePanel(productSequenceNumber: number): void {
        this.router.navigate(['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.SelfService, MyZoneRoutesEnum.Cancel], {
            queryParams: {
                productSequenceNumber: productSequenceNumber,
                panel: SelectedPanelEnum.Close,
            },
        });
    }

    public onOpenPanel(productSequenceNumber: number): void {
        this.router.navigate(['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.SelfService, MyZoneRoutesEnum.Cancel], {
            queryParams: {
                productSequenceNumber: productSequenceNumber,
                panel: SelectedPanelEnum.InsuranceEndProduct,
            },
        });
    }

    public getProductIconName(productId: PolicyProductIdEnum): IconGeneralIcon {
        return productIconConfig[productId] ?? '' as IconGeneralIcon;
    }

    public reviveProduct(): void {
        this.insurancePolicyActionService
            .reviveProduct$({
                productId: this.purchasedProduct.productId,
                productSequenceNumber: this.purchasedProduct.productSequenceNumber,
            })
            .subscribe({
                next: () => this.onReviveProductSuccess(),
                error: (errors) => this.onReviveProductError(errors),
            });

        this.isDisabled = true;
        this.errors = [];
    }

    public get isVehicle(): boolean {
        return Boolean([
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Motorcycle,
        ].includes(this.purchasedProduct.productId));
    }

    private onReviveProductSuccess(): void {
        this.isDisabled = false;
        this.errors = [];
    }

    private onReviveProductError(errors: ErrorInterface[]): void {
        this.isDisabled = false;
        this.errors = errors;
    }

    private validateQueryParams(): void {
        this.route.queryParams
            .pipe(
                filter((params) =>
                    Boolean(params.productSequenceNumber && params.panel)),
            )
            .subscribe((params) => this.handleQueryParams(params));
    }

    private handleQueryParams(params): void {
        const productSequenceNumber: number = Number(params.productSequenceNumber);

        if (
            params.panel !== SelectedPanelEnum.Close
            && productSequenceNumber === this.purchasedProduct.productSequenceNumber
        ) {
            this.panel.open();
        } else {
            this.panel.close();
        }
   }

}
